import { useLanguage } from '@/hooks/useLanguage';
import { getLanguage as getInterfaceLanguage } from '@/utils/i18n';
import React, { useState, useEffect } from 'react';
import { Input } from '@/components/ui/input';

interface CurrencyInputProps {
  value?: number; // em centavos
  onChange: (value: number | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

export function CurrencyInput({ value, onChange, placeholder, disabled, className }: CurrencyInputProps) {
  useLanguage();
  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    if (value !== undefined && value > 0) {
      setDisplayValue(formatCentsToDisplay(value));
    } else {
      setDisplayValue('');
    }
  }, [value]);

  const formatCentsToDisplay = (cents: number): string => {
    const reais = cents / 100;
    return reais.toLocaleString(getInterfaceLanguage(), {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const parseDisplayToCents = (display: string): number | undefined => {
    const cleanValue = display.replace(/[^\d,]/g, '').replace(',', '.');
    const parsed = parseFloat(cleanValue);
    if (isNaN(parsed) || parsed <= 0) return undefined;
    return Math.round(parsed * 100);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    
    // Remove tudo exceto dígitos e vírgula
    const cleaned = input.replace(/[^\d,]/g, '');
    
    // Limita a 2 casas decimais
    const parts = cleaned.split(',');
    if (parts[1] && parts[1].length > 2) {
      parts[1] = parts[1].substring(0, 2);
    }
    const formatted = parts.join(',');
    
    setDisplayValue(formatted);
    
    // Converter para centavos e notificar
    const cents = parseDisplayToCents(formatted);
    onChange(cents);
  };

  const handleBlur = () => {
    if (displayValue && value) {
      setDisplayValue(formatCentsToDisplay(value));
    }
  };

  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground text-sm">
        R$
      </span>
      <Input
        type="text"
        value={displayValue}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder || '0,00'}
        disabled={disabled}
        className={`pl-10 ${className}`}
      />
    </div>
  );
}
